export function WalletWebsocket(setTRXAPIData) {
  // const ws = new WebSocket("wss://stream.binance.com:9443/ws/!miniTicker@arr");

  let ws;
  let reconnectTimer;

  const connent = () => {
    ws = new WebSocket(
      "wss://stream.binance.com:9443/stream?streams=trxusdt@ticker",
    );

    ws.onmessage = (event) => {
      const { stream, data } = JSON.parse(event.data);

      switch (stream) {
        case "trxusdt@ticker":
          setTRXAPIData(data);
          break;
      }
    };

    ws.onerror = (err) => {
      ws.close();
    };

    ws.onclose = () => {
      reconnectTimer = setTimeout(() => {
        // connent();
      }, 300);
    };
  };
  connent();

  return () => {
    clearTimeout(reconnectTimer);
    ws?.close();
  };
}
